import { render, staticRenderFns } from "./ProjectGroupNewFrProject.vue?vue&type=template&id=c0821aa6"
import script from "./ProjectGroupNewFrProject.vue?vue&type=script&lang=js"
export * from "./ProjectGroupNewFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports